class MmgsmAnnouncementBar extends HTMLElement {
  connectedCallback() {
    this.slides = Array.from(this.querySelectorAll('.mmgsm-announcement-bar__slide'));
    if (this.slides.length <= 1) return;

    this.speedMs = Number(this.dataset.speedMs || 5000);
    this.index = 0;
    this._timer = setInterval(() => this.next(), this.speedMs);
  }

  disconnectedCallback() {
    clearInterval(this._timer);
  }

  next() {
    this.slides[this.index].hidden = true;
    this.index = (this.index + 1) % this.slides.length;
    this.slides[this.index].hidden = false;
  }
}

if (!customElements.get('mmgsm-announcement-bar')) {
  customElements.define('mmgsm-announcement-bar', MmgsmAnnouncementBar);
}
